import { WebQuestion } from "../types/webQuestion";
import { TypeEnum } from "../types/answerTemplate";

export function isURL(str: string) {
  const pattern = /^(https?:\/\/|www\.)[^\s/$.?#].[^\s]*$/i;
  return pattern.test(str);
}
export const questionHasRedirectUrl = (question?: WebQuestion) => {
  return (
    (question?.answerTemplate?.type === TypeEnum.END_BLOCK || question?.answerTemplate === null) &&
    isURL(question?.redirectPath ?? "")
  );
};

export const redirectHandler = (question: WebQuestion) => {
  if (questionHasRedirectUrl(question)) {
    const redirect = () => {
      window.location.replace(question.redirectPath ?? "");
    };

    if (!question.endBlock) {
      redirect();
    } else {
      setTimeout(redirect, 3000);
    }
  }
};
